"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validate = require("validate.js");
exports.default = (value, options) => {
    return new validate.Promise(function (resolve) {
        options.client.suggestions
            .validate(value, options.suggestionName)
            .then(data => {
            if (!data.valid) {
                return resolve(data.errorMessage);
            }
            resolve();
        });
    });
};
//# sourceMappingURL=remoteSuggestionValidator.js.map